import React from 'react';
import {UsePermissions} from "../../hooks/usePermissions";

import {Navigate} from "react-router";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {InformeFondos} from "../../components/Informes/InformeFondos";

export const InformeFondosPage = () => {
    const [permisos] = UsePermissions();
    return (
        <div className="container-relative">
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>
            <ContainerTable>
                <div className="px-2">
                    {permisos.consultar ? <InformeFondos />: <Navigate to="/home"/>}
                </div>
            </ContainerTable>
        </div>
    );
}
